import { Loading } from '@/components/ui/daisy';
import usePedContentFilter from '@/data/hook/ped-content/usePedContentFilter';
import usePedagogicalContents from '@/data/hook/ped-content/usePedagogicalContents';
import PedContentCard from './PedContentCard';
import PedContentFilterBar from './PedContentFilterBar';
import PedContentFormList from './PedContentFormList';

type PedContentTabContentProps = {
  moduleId: number;
  courseLineId: number;
};

export default function PedContentTabContent({
  moduleId,
  courseLineId,
}: PedContentTabContentProps) {
  const { status, setStatus, filters } = usePedContentFilter();
  const {
    coursePaths,
    isLoading,
    createCoursePath,
    isCreating,
    deleteCoursePath,
    isDeleting,
    createVersion,
  } = usePedagogicalContents({ moduleId, courseLineId, filters });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loading variant="spinner" size="lg" color="primary" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6 min-w-0">
      <PedContentFilterBar
        status={status}
        onStatusChange={setStatus}
        total={coursePaths.length}
      />

      {coursePaths.map(coursePath => (
        <PedContentCard
          key={coursePath.id}
          coursePath={coursePath}
          courseLineId={courseLineId}
          moduleId={moduleId}
          onDelete={deleteCoursePath}
          onCreateVersion={createVersion}
          isDeleting={isDeleting}
        />
      ))}
      <PedContentFormList onSubmit={createCoursePath} isLoading={isCreating} />
    </div>
  );
}
